import {useContext} from 'react';
import AuthorizedFunction from '@security/AuthorizedFunction';
import Acompanhamento from '@pages/Acompanhamento';
import Inicio from '@pages/Inicio';
import Atividade from '@pages/Atividade';
import Contagem from '@pages/Contagem';
import Triagem from '@pages/Triagem';
import {ConteudoObjetoPostal, ObjetoPostal} from '@pages/ObjetoPostal';
import Portaria from '@pages/Portaria';
import Scanner from '@pages/Scanner';
import TipoPendencia from '@pages/TipoPendencia';
import Escola from '@pages/Escola';
import ListagemEscolas from '@pages/Escola/ListagemEscolas';
import ListagemCaixas from '@pages/Caixa/ListagemCaixas';
import DashboardTratamentoNomes from '@pages/TratamentoNomes/DashboardTratamentoNomes'
import DashboardTratamentoDataNacimento from "@pages/TratamentoDataNascimento/DashboardTratamentoDataNascimento";
import DashboardTratamentoCPF from "@pages/TratamentoCPF/DashboardTratamentoCPF";
import ListagemEmpresasPageView from '@pages/Empresas/ListagemEmpresasPageView';
import ListagemColaboradoresPageView from '@pages/Colaboradores/ListagemColaboradoresPageView';
import ListagemCartoesPorEscola from '@pages/Escola/Cartoes/ListagemCartoesPorEscola';
import ListagemCartoesDuplicados from '@pages/TratamentoCartoesDuplicados/ListagemCartoesDuplicados';
import ListagemCartoesIntrusos from '@pages/Escola/Cartoes/ListagemCartoesIntrusos';
import ListagemCartoesIlegiveis from '../components/pages/Escola/Cartoes/ListagemCartoesIlegiveis';
import Pendencia from '@pages/Pendencia';
import RegistrarPendenciasEnvelope from '@pages/Pendencia/RegistrarPendenciasEnvelope';
import Processo from '@pages/Processo';
import InformarCartaoResposta from '@pages/InformarCartaoResposta';
import DigitarCartao from '@pages/DigitarCartao';
import ListagemCartoes from '@pages/Escola/Cartoes/ListagemCartoes';
import DigitarDe from '@pages/DigitarDe';
import Logs from '@pages/Logs';
import LogsIntegracao from '@pages/LogsIntegracao';
import DesempenhoColaboradores from '@pages/DesempenhoColaboradores';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Filter1Icon from '@material-ui/icons/Filter1';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import BusinessCenterOutlinedIcon from '@material-ui/icons/BusinessCenterOutlined';
import SchoolOutlinedIcon from '@material-ui/icons/SchoolOutlined';
import FilterNoneOutlinedIcon from '@material-ui/icons/FilterNoneOutlined';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import MarkunreadMailboxOutlinedIcon from '@material-ui/icons/MarkunreadMailboxOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import TextureOutlinedIcon from '@material-ui/icons/TextureOutlined';
import RecentActorsOutlinedIcon from '@material-ui/icons/RecentActorsOutlined';
import KeyboardOutlinedIcon from '@material-ui/icons/KeyboardOutlined';
import SpellcheckOutlinedIcon from '@material-ui/icons/SpellcheckOutlined';
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined';
import CollectionsBookmarkOutlinedIcon from '@material-ui/icons/CollectionsBookmarkOutlined';
import AllInboxOutlinedIcon from '@material-ui/icons/AllInboxOutlined';
import LibraryAddCheckOutlinedIcon from '@material-ui/icons/LibraryAddCheckOutlined';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import PlaylistAddCheckOutlinedIcon from '@material-ui/icons/PlaylistAddCheckOutlined';
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined';
import AddBoxOutlined from '@material-ui/icons/AddBoxOutlined';
import ReportOutlinedIcon from '@material-ui/icons/ReportOutlined';
import KeyboardHideOutlinedIcon from '@material-ui/icons/KeyboardHideOutlined';
import EventAvailableOutlinedIcon from '@material-ui/icons/EventAvailableOutlined';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import FilterListIcon from '@material-ui/icons/FilterList';
import {ProcessoContext} from '@contexts/ProcessoContext';
import {TratamentoDiscrepanciaDE} from "@pages/Escola/TratamentoDiscrepanciaDE";
import TratamentoCartoesDuplicados from "../components/pages/TratamentoCartoesDuplicados/TratamentoCartoesDuplicados";
import TratamentoNomesDuplicados from "../components/pages/TratamentoNomesDuplicados/TratamentoNomesDuplicados";
//import ListagemObjetoPostalComIntruso from "@pages/TratamentoObjetosPostaisComInstrusos/ListagemObjetoPostalComIntruso";
import Armazenar from "@pages/Armazenar/Armazenar";
import DashboardTratamentoNomesDuplicados from "../components/pages/TratamentoNomesDuplicados/DashboardTratamentoNomesDuplicados";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ListagemAjuda from '@pages/Ajuda/ListagemAjuda';
import DashboardTratamentoNotasZero from "../components/pages/TratamentoNota/DashboardTratamentoNotas";
import ScannerOutlinedIcon from '@material-ui/icons/ScannerOutlined';
import AcompanhamentoGrafico from "../components/pages/AcompanhamentoGrafico";
import Digitacao from '@pages/Digitacao';
//import EticketsRegistrados from '@pages/EticketsRegistrados';
import TextFieldsOutlinedIcon from '@material-ui/icons/TextFieldsOutlined';
import FingerprintIcon from '@material-ui/icons/Fingerprint';

export function MenuRoute() {
  const {processo} = useContext(ProcessoContext);

  let items = [
    {
      path: `/`,
      name: 'Início',
      icon: null,
      component: Inicio,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
    },
    {
      path: `/processos`,
      name: 'Processo',
      icon: BusinessCenterOutlinedIcon,
      component: Processo,
      collapsed: false,
      showOnMenu: !processo.id,
      submenus: [],
      roles: [],
    },
    {
      path: `/:processo?/acompanhamento`,
      name: 'Acompanhamento',
      icon: AssessmentOutlinedIcon,
      component: Acompanhamento,
      collapsed: false,
      showOnMenu: !!(processo.id && (AuthorizedFunction(["__processo.acompanhamento"]))),
      submenus: [],
      roles: ["__processo.acompanhamento"],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: ``,
      name: 'Gerenciar',
      icon: SupervisorAccountOutlinedIcon,
      divider: true,
      component: () => {
        return null
      },
      collapsed: true,
      showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.gerencia"])),
      submenus: [
        {
          path: `/empresas`,
          name: 'Empresas',
          icon: BusinessOutlinedIcon,
          component: ListagemEmpresasPageView,
          collapsed: false,
          showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.colaboradores"])),
          submenus: [],
          roles: [],
        },
        {
          path: `/colaboradores`,
          name: 'Colaboradores',
          icon: PersonOutlineOutlinedIcon,
          component: ListagemColaboradoresPageView,
          collapsed: false,
          showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.colaboradores"])),
          submenus: [],
          roles: [],
        },
        {
          path: `/atividades`,
          name: 'Atividades',
          icon: AssignmentTurnedInOutlinedIcon,
          component: Atividade,
          collapsed: false,
          showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.administrador"])),
          submenus: [],
          roles: ["__processo.usuario.administrador"],
        },
        {
          path: `/:processo?/tiposPendencia`,
          name: 'Tipos de Pendências',
          icon: AssignmentLateOutlinedIcon,
          component: TipoPendencia,
          collapsed: false,
          showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.administrador"])),
          submenus: [],
          roles: ["__processo.usuario.administrador"],
          params: [
            {
              name: "processo",
              value: processo.id
            }
          ]
        },
        {
          path: `/:processo?/ajuda`,
          name: 'Textos de Ajuda',
          icon: HelpOutlineIcon,
          component: ListagemAjuda,
          collapsed: false,
          showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.administrador"])),
          submenus: [],
          roles: ["__processo.usuario.administrador"],
          params: [
            {
              name: "processo",
              value: processo.id
            }
          ]
        },
        {
          path: `/:processo?/desempenho`,
          name: 'Desempenho dos Colaboradores',
          icon: TimelineOutlinedIcon,
          component: DesempenhoColaboradores,
          collapsed: false,
          showOnMenu: !!(processo.id && (AuthorizedFunction(["__processo.desempenhocolaboradores"]))),
          submenus: [],
          roles: [],
          params: [
            {
              name: "processo",
              value: processo.id
            }
          ]
        },
        {
          path: `/:processo?/acompanhamentoGrafico`,
          name: 'Acompanhamento Gráfico',
          icon: AssessmentOutlinedIcon,
          component: AcompanhamentoGrafico,
          collapsed: false,
          showOnMenu: !!(processo.id && (AuthorizedFunction(["__processo.acompanhamento"]))),
          submenus: [],
          roles: ["__processo.acompanhamento"],
          params: [
            {
              name: "processo",
              value: processo.id
            }
          ]
        },
        {
          path: `/:processo?/logs`,
          name: 'Logs do Aplicativo',
          icon: FlagOutlinedIcon,
          component: Logs,
          collapsed: false,
          showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.logsaplicativo"])),
          submenus: [],
          roles: ["__processo.usuario.administrador"],
          exact: true,
          params: [
            {
              name: "processo",
              value: processo.id
            }
          ]
        },
      ],
      roles: ["__processo.usuario.administrador"],
    },
    {
      path: `/:processo?/portaria`,
      name: 'Recebimento',
      icon: LocalShippingOutlinedIcon,
      component: Portaria,
      collapsed: false,
      showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.portaria"])),
      submenus: [],
      roles: ["__processo.usuario.portaria"],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/triagem`,
      name: 'Triagem',
      icon: FilterListIcon,
      component: Triagem,
      collapsed: false,
      showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.lancadortriagem"])),
      submenus: [],
      roles: ["__triagem.lancamento"],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/contagem/:recontagem?`,
      name: 'Lançamento',
      icon: Filter1Icon,
      component: Contagem,
      collapsed: false,
      showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.lancadorcontagem"])),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        },
        {
          name : "recontagem",
          value: false
        }
      ]
    },
    {
      path: `/:processo?/digitalizacao`,
      name: 'Digitalizaçâo',
      icon: ScannerOutlinedIcon,
      component: Scanner,
      collapsed: false,
      showOnMenu: !!(processo.id && (AuthorizedFunction(["__processo.usuario.scanner"]) || AuthorizedFunction(["__processo.usuario.administrador"]))),
      submenus: [],
      roles: [ "__processo.usuario.scanner", "__processo.usuario.administrador"],
      params: [
        {
          name: "processo",
          value: processo.id
        },
      ]
    },
    {
      path: `/:processo?/digitacao`,
      name: 'Digitação',
      icon: KeyboardOutlinedIcon,
      component: Digitacao,
      collapsed: false,
      showOnMenu: !!(processo.id && (AuthorizedFunction(["__processo.usuario.digitador"]) || AuthorizedFunction(["__processo.usuario.administrador"]))),
      submenus: [],
      roles: [ "__processo.usuario.digitador", "__processo.usuario.administrador"],
      params: [
        {
          name: "processo",
          value: processo.id
        },
      ]
    },

    {
      path: `/:processo?/recontagem/:recontagem?`,
      name: 'Recontagem',
      icon: CollectionsBookmarkOutlinedIcon,
      component: Contagem,
      collapsed: false,
      showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.administrador"])),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        },
        {
          name : "recontagem",
          value: true
        }
      ]
    },
    {
      path: `/:processo?/armazenar`,
      name: 'Armazenagem',
      icon: LibraryAddCheckOutlinedIcon,
      component: Armazenar,
      collapsed: false,
      showOnMenu: !!(processo.id && AuthorizedFunction(["__processo.usuario.armazenador"])),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ],
      divider: true
    },
    {
      path: `/:processo?/pistolagemCartoes`,
      name: 'Recebimento de Cartões',
      icon: AddBoxOutlined,
      component: InformarCartaoResposta,
      collapsed: false,
      showOnMenu: !!(processo.id &&  AuthorizedFunction(["__processo.usuario.central"])),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/de`,
      name: 'Digitar DE',
      icon: KeyboardHideOutlinedIcon,
      component: DigitarDe,
      collapsed: false,
      showOnMenu: !!(processo.id &&  AuthorizedFunction(["__de.digitar"])),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/escola/:escola?/de/:id?`,
      name: 'Digitar DE - Escola',
      icon: KeyboardHideOutlinedIcon,
      component: DigitarDe,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/pendencias/registrar`,
      name: 'Registrar Pendências',
      icon: ReportProblemOutlinedIcon,
      component: RegistrarPendenciasEnvelope,
      collapsed: false,
      showOnMenu: !!(processo.id && (AuthorizedFunction(["__processo.usuario.central"]))),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ],
      divider: true
    },

    {
      path: `/:processo?/objetosPostais`,
      name: 'Objetos Postais',
      icon: MarkunreadMailboxOutlinedIcon,
      component: ObjetoPostal,
      collapsed: false,
      showOnMenu: processo.id && AuthorizedFunction(["__processo.usuario.central"]),
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    // {
    //   path: `/:processo?/eticketsRegistrados`,
    //   name: 'Etickets Registrados',
    //   icon: MarkunreadMailboxOutlinedIcon,
    //   component: EticketsRegistrados,
    //   collapsed: false,
    //   showOnMenu: processo.id && AuthorizedFunction(["__processo.usuario.central"]),
    //   submenus: [],
    //   roles: [],
    //   exact: true,
    //   params: [
    //     {
    //       name: "processo",
    //       value: processo.id
    //     }
    //   ]
    // },
    {
      path: `/:processo?/caixas`,
      name: 'Caixas',
      icon: AllInboxOutlinedIcon,
      component: ListagemCaixas,
      collapsed: false,
      showOnMenu: !!(processo.id && (AuthorizedFunction(["__processo.usuario.central"]))),
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/escolas`,
      name: 'Escolas',
      icon: SchoolOutlinedIcon,
      component: ListagemEscolas,
      collapsed: false,
      showOnMenu: !!(processo.id &&  AuthorizedFunction(["__escolas.listar"])),
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/cartoes`,
      name: 'Cartões',
      icon: FilterNoneOutlinedIcon,
      component: ListagemCartoes,
      collapsed: false,
      showOnMenu: !!(processo.id && (AuthorizedFunction(["__processo.usuario.central"]))),
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ],
      divider: true
    },
    {
      path: `/:processo?/escola/:escola?/cartoes`,
      name: 'Visualizar Cartões',
      icon: FilterNoneOutlinedIcon,
      component: ListagemCartoesPorEscola,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/digitarCartoes`,
      name: 'Digitar Cartões',
      icon: KeyboardOutlinedIcon,
      component: DigitarCartao,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/pendencias`,
      name: 'Tratamento de Pendências',
      icon: PlaylistAddCheckOutlinedIcon,
      component: Pendencia,
      collapsed: false,
      showOnMenu: !!(processo.id && AuthorizedFunction(["__pendencias.tratar"])),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ],

    },

    {
      path: `/:processo?/tratamentoDiscrepanciaDE`,
      name: 'Tratamento de Discrepância de D.E.',
      icon: HighlightOffIcon,
      component: TratamentoDiscrepanciaDE,
      collapsed: false,
      showOnMenu: !!(processo.id && AuthorizedFunction(["__tratamento.discrepanciade"])),
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/cartoes/duplicados`,
      name: 'Tratamento de Cartões Duplicados',
      icon: RecentActorsOutlinedIcon,
      component: ListagemCartoesDuplicados,
      collapsed: false,
      showOnMenu: !!(processo.id &&  AuthorizedFunction(["__tratamento.cartoesduplicados"])),
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/cartoes/intrusos`,
      name: 'Tratamento de Cartões Intrusos',
      icon: ReportOutlinedIcon,
      component: ListagemCartoesIntrusos,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    // {
    //   path: `/:processo?/objetosPostaisComIntrusos`,
    //   name: 'Tratamento de Cartões Intrusos',
    //   icon: ReportOutlinedIcon,
    //   component: ListagemObjetoPostalComIntruso,
    //   collapsed: false,
    //   showOnMenu: processo.id && AuthorizedFunction(["__tratamento.cartoesintrusos"]),
    //   submenus: [],
    //   roles: [],
    //   exact: true,
    //   params: [
    //     {
    //       name: "processo",
    //       value: processo.id
    //     }
    //   ]
    // },
    {
      path: `/:processo?/cartoes/ilegiveis`,
      name: 'Tratamento de Cartões Ilegíveis',
      icon: TextureOutlinedIcon,
      component: ListagemCartoesIlegiveis,
      collapsed: false,
      showOnMenu: processo.id &&  AuthorizedFunction(["__tratamento.ilegiveis"]),
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/tratamentoDataNascimento`,
      name: 'Tratamento de Data de Nascimento',
      icon: EventAvailableOutlinedIcon,
      component: DashboardTratamentoDataNacimento,
      collapsed: false,
      showOnMenu: processo.id && AuthorizedFunction(["__tratamento.datanascimento"]),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/tratamentoCpf`,
      name: 'Tratamento de CPF',
      icon: FingerprintIcon,
      component: DashboardTratamentoCPF,
      collapsed: false,
      showOnMenu: processo.id && AuthorizedFunction(["__tratamento.datanascimento"]),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },


    {
      path: `/:processo?/tratamentosDeNomes`,
      name: 'Tratamento de Nomes',
      icon: SpellcheckOutlinedIcon,
      component: DashboardTratamentoNomes,
      collapsed: false,
      showOnMenu: processo.id && AuthorizedFunction(["__tratamento.nome"]),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/tratamentosDeNomesDuplicados`,
      name: 'Tratamento de Nomes Duplicados',
      icon: TextFieldsOutlinedIcon,
      component: DashboardTratamentoNomesDuplicados,
      collapsed: false,
      showOnMenu: processo.id && AuthorizedFunction(["__tratamento.nomeduplicadoescola"]),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/tratamentosDeNomesDuplicados/:codigo`,
      name: 'Tratamento de Nomes Duplicados',
      component: TratamentoNomesDuplicados,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/tratamentosDeNotas`,
      name: 'Tratamento de Notas Zero',
      icon: AssignmentLateOutlinedIcon,
      component: DashboardTratamentoNotasZero,
      collapsed: false,
      showOnMenu: processo.id && AuthorizedFunction(["__tratamento.nomeduplicadoescola"]),
      submenus: [],
      roles: [],
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },

    {
      path: `/:processo?/escola/:escola?`,
      name: 'Escolas',
      icon: SchoolOutlinedIcon,
      component: Escola,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/objetosPostais/:codigoObjetoPostal`,
      name: 'Conteúdo Objeto Postal',
      component: ConteudoObjetoPostal,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/objetosPostais/:codigoObjetoPostal/:intruso`,
      name: 'Conteúdo Objeto Postal',
      component: ConteudoObjetoPostal,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/logsIntegracao`,
      name: 'Erros Integração E2DOC / Teleform / Digitação',
      icon: HighlightOffOutlinedIcon,
      component: LogsIntegracao,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
    {
      path: `/:processo?/tratamentoCartoesDuplicados/:codigo`,
      name: 'Tratamento de cartões Duplicados',
      component: TratamentoCartoesDuplicados,
      collapsed: false,
      showOnMenu: false,
      submenus: [],
      roles: [],
      exact: true,
      params: [
        {
          name: "processo",
          value: processo.id
        }
      ]
    },
  ];

  return [
    {
      category: '',
      items: [...items],
    },
  ];

}

export default MenuRoute;
